import React from 'react';
import { withTranslation } from "react-i18next";

class KrstudioPopup extends React.Component {
  constructor(props) {
    super(props);
    const {t} = props;
    const metricId = typeof props.keyResult.id !== 'undefined' ? props.keyResult.id : 'new';
    this.iframeSrc = typeof props.iframeSrc !== 'undefined' ? props.iframeSrc : 'https://mskrstudio.azurefd.net/workboardentry';
    this.handleMessage = this.handleMessage.bind(this);
    // We need to build the key result shared object
    const sharedObject = {
      krAttributes: { name: t('New Key Result') }
    };
    if (typeof props.keyResult !== 'undefined') {
      sharedObject.krAttributes = { ...props.keyResult };
      if (typeof props.keyResultName !== 'undefined' && props.keyResultName.length > 0) {
        sharedObject.krAttributes.name = props.keyResultName;
      }
      if(typeof props.krAssociation !== 'undefined'){
        sharedObject.krAttributes.krAssociation = props.krAssociation;
      }
    }
    if (typeof props.objective !== 'undefined') {
      sharedObject.krAttributes.objective = { ...props.objective };
    }

    if (typeof loggedInUserOrgId !== 'undefined') {
      sharedObject.krAttributes.orgId = loggedInUserOrgId;
    }

    this.state = {
      metricId: metricId,
      sharedObject : sharedObject,
      iFrameBaseUrl : this.iframeSrc
    };
  }

  componentDidMount() {
    window.addEventListener('message', this.handleMessage);
  }

  componentWillUnmount() {
    window.removeEventListener('message', this.handleMessage);
  }

  handleMessage(event) {
    const frame = document.getElementById('wobo-external-app-container');
    // once message is received, we need to send the message back to child
    console.log(`Sending message to origin: ${event.origin}`);
    switch (event.data.func) {
      case "initialize":
        // eslint-disable-next-line no-case-declarations
        console.log("initialize: sharing metric object %o", this.state.sharedObject);
        frame.contentWindow.postMessage(woboClients.createMessage(event.data.args.func, this.state.sharedObject), event.origin);
        break;
      case "successReceived":
        console.log('successReceived: %o', event.data);
        this.props.continue(event.data.args.sharedObject.krAssociation);
        break;
      case "cancelReceived":
        console.log('cancelReceived: %o', event.data);
        if (this.state.metricId !== 'new'
          && event.data.args.sharedObject.krAssociation.constructor === Object
          && Object.keys(event.data.args.sharedObject.krAssociation).length > 0
          && event.data.args.sharedObject.krAssociation.id !== undefined
        ) {
          if (typeof event.data.args.sharedObject.krAssociation.url === "undefined") {
            event.data.args.sharedObject.krAssociation.url = this.state.iFrameBaseUrl;
          }
          this.props.continue(event.data.args.sharedObject.krAssociation);
        } else {
          this.props.closePopUp();
        }
        break;
      case "discardReceived":
        this.props.discard();
        break;
      default:
        console.log('Unknown event: %o', event);
    }
  }

  render() {
    return (
      <div id="myModal" className="aEmodal" keys={Math.random()}>
        <div className="mskr-studio-modal">
          <div className="wobo-embedded-external-views">
            <iframe className="wobo-embedded-iframe page-content" name="wobo-external-app-container" id="wobo-external-app-container" sandbox="allow-popups allow-scripts allow-same-origin allow-forms" allow="geolocation *;" data-wobo-id="embeddedPageContainerIframe" allowFullScreen="" width="800px" height="660px" src={this.iframeSrc}>
              {t('KR Studio setup')}
            </iframe>
          </div>
        </div>
      </div>
    );
  }
}

export default withTranslation()(KrstudioPopup);
